import React from 'react';
import { toast } from 'react-toastify'

const Home = ({ history }) => {
  if (history?.location?.state?.toastMsg) toast(history.location.state.toastMsg.msg, history.location.state.toastMsg.params);

  return <div></div>
}

export default Home
